import { Reveal } from "./Reveal";
import { SevenPointStar, JordanFlag } from "./Star";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-jordan-ink text-jordan-sand">
      <div className="mx-auto max-w-[1600px] px-5 pb-14 pt-24 sm:px-10 sm:pt-36">
        <Reveal>
          <p className="mb-6 font-display text-xs font-bold uppercase tracking-[0.3em] text-jordan-red">
            Ahlan wa sahlan · أهلاً وسهلاً
          </p>
          <h2 className="font-display text-[13vw] font-black uppercase leading-[0.88] tracking-tighter sm:text-[9vw]">
            You are<br />
            <span className="text-outline-sand">welcome</span> here
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-16 flex flex-col gap-10 border-t border-jordan-sand/15 pt-12 sm:mt-24 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex items-center gap-4">
            <img src="/assets/logo.png" alt="The Jordanian Hub emblem" className="h-16 w-auto invert" data-testid="footer-logo" />
            <div className="leading-tight">
              <p className="font-display text-sm font-extrabold uppercase tracking-[0.2em]">The Jordanian Hub</p>
              <p className="font-arabic text-sm text-jordan-sand/60">المضافة الأردنية · Almadafah</p>
            </div>
          </div>
          <nav className="flex flex-col gap-3 font-display text-xs font-bold uppercase tracking-[0.22em]" data-testid="footer-nav">
            <a href="#about" data-testid="footer-about-link" className="link-underline w-fit text-jordan-sand/80 hover:text-jordan-sand">About</a>
            <a href="#pillars" data-testid="footer-pillars-link" className="link-underline w-fit text-jordan-sand/80 hover:text-jordan-sand">Pillars</a>
            <a href="#donate" data-testid="footer-donate-link" className="link-underline w-fit text-jordan-sand/80 hover:text-jordan-sand">Donate</a>
          </nav>
          <div className="max-w-xs text-sm leading-relaxed text-jordan-sand/60">
            <p>
              A community-focused organisation bringing people together, strengthening
              connections and celebrating Jordanian culture in Australia.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <JordanFlag className="h-5 w-9" />
              <SevenPointStar className="h-4 w-4 text-jordan-red" />
              <span className="font-display text-[10px] font-bold uppercase tracking-[0.25em] text-jordan-sand/50">
                Jordan → Australia
              </span>
            </div>
          </div>
        </Reveal>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-jordan-sand/15 pt-8 text-xs text-jordan-sand/40 sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} The Jordanian Hub · Almadafah. All rights reserved.</p>
          <p className="font-arabic text-base text-jordan-sand/50">من الأردن إلى أستراليا، القلب واحد</p>
        </div>
      </div>
    </footer>
  );
}
